import type { TableCell } from 'mdast';

import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

import type { FromPMHandlers } from '../types';

export function tableRow(
	node: PMNode,
	handlers: FromPMHandlers,
): { children: TableCell[]; type: 'tableRow' } {
	const cells: TableCell[] = [];
	node.forEach((child) => {
		const handler = handlers[child.type.name];
		if (handler) {
			const result = handler(child);
			if (result && !Array.isArray(result) && result.type === 'tableCell') {
				cells.push(result as TableCell);
			}
		}
	});
	return { type: 'tableRow' as const, children: cells };
}
